export default ['Fungsi Hunian', 'Fungsi Keagamaan', 'Fungsi Usaha', 'Fungsi Sosial dan Budaya', 'Fungsi Khusus', 'Fungsi Campuran']
